import aa from "search-insights"
import { createInsightsMiddleware } from "instantsearch.js/es/middlewares"
import { useInstantSearch } from "react-instantsearch"
import { useLayoutEffect } from "react"
import { getUserToken } from "./AlgoliaAnalytics"

// Get User Token
const userToken = getUserToken()

// Insights Middleware to track user interactions (click events) out the box with Algolia v.7
export default function InsightsMiddleware() {
  const { addMiddlewares } = useInstantSearch()

  useLayoutEffect(() => {
    const middleware = createInsightsMiddleware({
      insightsClient: aa,
      insightsInitParams: {
        useCookie: true,
      },
    })

    aa("setUserToken", userToken)

    return addMiddlewares(middleware)
  }, [addMiddlewares])

  return null
}
